import { useState, useEffect } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormSubsidiaryRights, { FORM_SUBSIDIARY_RIGHTS_ID } from '../forms/FormSubsidiaryRights';
import { useTranslation } from 'react-i18next';

export default function SheetSubsidiaryRights({ open, onOpenChange, subsidiary, onSubmit, isSubmitting }) {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);

    useEffect(() => {
        if (open) {
            setResetKey((k) => k + 1);
        }
    }, [open]);

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0 gap-0"
                showCloseButton={false}
            >
                <SheetHeader className="p-5 border-b border-border flex-shrink-0">
                    <SheetTitle className="text-[18px] text-foreground">
                        {t('subsidiary:accesDe')} {subsidiary?.name ?? t('subsidiary:duSousCompte')}
                    </SheetTitle>
                </SheetHeader>

                <FormSubsidiaryRights key={resetKey} subsidiary={subsidiary} onSubmit={onSubmit} />

                <SheetFooter className="p-5 border-t border-border flex-shrink-0">
                    <SubmitButton
                        isSubmitting={isSubmitting}
                        loadingText={t('subsidiary:enregistrement2')}
                        form={FORM_SUBSIDIARY_RIGHTS_ID}
                        className="w-full text-foreground rounded-xl py-3.5 h-auto text-[14px]"
                    >
                        {t('subsidiary:enregistrer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
